import { ajax } from "../services/ajax";
import { api } from "../constants";
import queryString from "../utils/queryString";

export const getHomeRequest = type => {
  return ajax.get(`${api.endpoints.home.getChannelItems}?${queryString({ type })}`)
}
export const saveHomeRequest = data => {
  return ajax.post(api.endpoints.home.addChannelItems, {data})
}
